// import '@/pages/intelligence_detail/components/Echarts/lineChart.less';

export const lineTooltipFormatter = (
  _param: string | any[],
  letTitle,
  rightTitle,
  valueFormatFun,
  isShowMarket = true,
) => {
  const param = _param; //moveZero(_param);  要区别排名的话是顺序，其他是倒序
  let allContent = '';
  let contentArr = [];
  let returnStr = `
  <div class="dbi-chart-bubble-title">
    <div class="bubble-title-flex" style="justify-content: space-between; flex-basis: 100%;">
      <div class="bubble-title-flex-text" style="width: auto;">${letTitle}</div>
      <div class="bubble-title-flex-text" style="width: auto;">${rightTitle}</div>
    </div>
  </div>`;
  for (let i = 0; i < param?.length; i++) {
    const nameVal = param[i]?.seriesName || '';
    const image = param[i]?.data?.cover || ''
    let value = '';
    if (typeof param[i].value === 'object') {
      value = param[i].value[1];
    } else {
      value = param[i].value;
    }
    let item = {
      market: `<span class="bubble-lf-round" style="background-color:${param[i].color};"></span>`,
      name: `<span class="bubble-lf-name">${nameVal}</span>`,
      image: image ? `<img src="${image}" width="24px" height="24px" style="margin-right: 6px"></img>`: '',
      value: `<span">${
        valueFormatFun ? valueFormatFun(value, param[i]?.data, param[i]) : value
      }</span>`,
    };
    contentArr?.push(item);
  }

  const getLine = contentArr?.map((v) => {
    return ` <div class="dbi-chart-bubble-item">
      <div class="dbi-chart-bubble-lf">${isShowMarket ? v?.market : ''} ${v?.image || ''} ${
      v?.name
    }</div>
      <div class="dbi-chart-bubble-rt">${v?.value}</div>
    </div>`;
  });

  let bodyContent = `${getLine?.join('')}`;
  allContent = `<div class="dbi-chart-bubble" >${returnStr} ${bodyContent}</div>`;

  return allContent;
};
